

































import {Component, Vue} from "vue-property-decorator";
import AnchorNav from "@/components/AnchorNav.vue";
import {RouterStore} from "@/interfaces/store-interfaces/router-store.interface";
import {bus} from "@/plugins/bus";
import {EventEmitter} from "@/interfaces/store-interfaces/event-emitter.interface";
import {localStorageService} from "@/services/local-storage.service";
import SocialShare from "@/components/SocialShare.vue";

@Component({
  components: {SocialShare, AnchorNav}
})

export default class StickyPanel extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;
  isEnd = false;
  isActionsVisible = false;
  isDetailPage = false;
  isShareVisible: boolean = false;
  isPathPage = false;
  isSearchPage: boolean = false;
  mediaQuery: any = null;
  stickyPanel: any = null;
  pathSections: any = null;
  activeSection: number = -1;
  isFavoriteFilm: boolean = false;

  get isMenuOpen() {
    return this.$store.state.dialog.menu;
  }

  get isKiosk() {
    return this.$store.state.rhizome.kioskMode;
  }

  created() {
    this.isDetailPage = this.$router.currentRoute.name === RouterStore.ROUTE_NAME.DETAIL_PAGE;
    this.isPathPage = this.$router.currentRoute.name === RouterStore.ROUTE_NAME.PATH_PAGE;
    this.isSearchPage = this.$router.currentRoute.name === RouterStore.ROUTE_NAME.SEARCH_PAGE;
  }

  mounted() {
    this.mediaQuery = window.matchMedia("(max-width: 992px)");

    bus.$on(EventEmitter.Events.DETAIL_SCROLLED, () => {
      this.isActionsVisible = !this.isActionsVisible;
    });

    bus.$on(EventEmitter.Events.DATA_LOADED, () => {
      setTimeout(() => {
        this.pathSections = document.querySelectorAll('.scroll-section');

        if (this.pathSections.length) {
          window.addEventListener('scroll', this.scrollAnchorNav);
          this.scrollAnchorNav();
        }
      });
    });

    if (this.isDetailPage) {
      bus.$on(EventEmitter.Events.DETAIL_PAGE_OFFSET_CALCULATED, this.calcTopPosition);
      this.mediaQuery.addListener(this.checkMedia);
      this.checkMedia({ matches: this.mediaQuery.matches });
      window.addEventListener('resize', this.calcTopPosition);
    }

    let filmId: number = Number(this.$router.currentRoute.params.id);
    this.isFavoriteFilm = localStorageService.getFavoriteList().includes(filmId);
  }

  toggleShare() {
    this.isShareVisible = !this.isShareVisible;
  }

  likeClickHandler() {
    localStorageService.toggleFavoriteFilm(Number(this.$router.currentRoute.params.id));
    this.isFavoriteFilm = !this.isFavoriteFilm;
  }

  calcTopPosition() {
    this.stickyPanel = document.querySelector('.sticky-panel');
    let filmDescription = document.querySelector('.film-description');
    let filmDescriptionRect = filmDescription.getBoundingClientRect();

    if (this.mediaQuery.matches) this.stickyPanel.style.top = filmDescriptionRect.top + window.scrollY + 'px';
  }

  checkMedia(e) {
    if (e.matches) {
      this.calcTopPosition();
      window.addEventListener('scroll', this.calcTopPosition);
    }
    else {
      window.removeEventListener('scroll', this.calcTopPosition);
      if (this.stickyPanel) {
        setTimeout( () => { this.stickyPanel.style.top = ''; } )
      }
    }
  }

  scrollToSection() {
    // If end wasn't reached
    if (this.activeSection !== (this.pathSections.length - 1)) {
      this.activeSection++;
      this.scrollToTarget(this.pathSections[this.activeSection]);

      // Change arrow direction when came to last section
      if (this.activeSection === (this.pathSections.length - 1)) {
        this.isEnd = true;
      }
    } else {
      // Scroll to first section
      this.scrollToTarget(this.pathSections[0]);
      this.isEnd = false;
    }
  }

  scrollToTarget(el) {
    let element = el;
    let headerOffset = 100;
    let elementPosition = window.pageYOffset + element.getBoundingClientRect().top;
    let offsetPosition = elementPosition - headerOffset;

    window.scrollTo(0 ,offsetPosition);
  }

  scrollAnchorNav() {
    if (!this.pathSections.length) return;

    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let headerOffset = 100;

    for (let i = 0; this.pathSections.length > i; i++) {
      let sectionPos = scrollTop + this.pathSections[i].getBoundingClientRect().top;

      if (scrollTop + headerOffset >= Math.floor(sectionPos)) {
        this.activeSection = i;
      }
    }

    if (scrollTop + headerOffset < this.pathSections[0].getBoundingClientRect().top) {
      this.activeSection = -1;
    }

    // Change arrow direction when came to last section
    this.isEnd = this.activeSection === (this.pathSections.length - 1);
  }

  addPressedStyle(event) {
    if (this.isKiosk) {
      event.target.classList.add('pressed');
    }
  }

  removePressedStyle(event) {
    if (this.isKiosk) {
      event.target.classList.remove('pressed');
    }
  }

  destroyed() {
    window.removeEventListener('scroll', this.scrollAnchorNav);
    window.removeEventListener('scroll', this.calcTopPosition);
    window.removeEventListener('resize', this.calcTopPosition);
    this.mediaQuery.removeListener(this.checkMedia);
    bus.$off(EventEmitter.Events.DETAIL_SCROLLED);
    bus.$off(EventEmitter.Events.PLAYER_READY);
    bus.$off(EventEmitter.Events.DATA_LOADED, this.calcTopPosition);
    bus.$off(EventEmitter.Events.DETAIL_PAGE_OFFSET_CALCULATED, this.calcTopPosition)
  }
}
